import { valueRegistry } from '../../../../registry/Registry';
export class TraitValue {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get trait() {
        return this.parent;
    }
    get aspect() {
        return this.trait.aspect;
    }
    get value() {
        if (typeof this.trait.value_stored === 'function') {
            return this.trait.value_stored();
        }
        if (this.trait.hasValueFromRegistry) {
            {
                const reg = valueRegistry.registry_object[this.trait.value_stored];
                if (reg) {
                    return reg.value(this.trait.toAttached.context);
                }
            }
        }
        return this.trait.value_stored;
    }
    // @computed
    get isDefaultValue() {
        return (typeof !['function', 'object'].includes(typeof this.trait.value) &&
            !!this.trait.reg.default &&
            this.trait.value === this.trait.reg.default);
    }
}
